import { render, staticRenderFns } from "./newsCore.vue?vue&type=template&id=39762caf&"
import script from "./newsCore.vue?vue&type=script&lang=js&"
export * from "./newsCore.vue?vue&type=script&lang=js&"
import style0 from "./newsCore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports